import React from 'react';
import {ScreenReaderOnly} from './StyledElements';

const ScreenReaderHelper: React.FC<IScreenReaderHelperProps> = ({href, text}) => (
   <ScreenReaderOnly data-test-id="screen-reader">
      <span
         id="aria-live-status"
         role="status"
         aria-live="polite"
      />
      <a href={href}>
         {text}
      </a>
   </ScreenReaderOnly>
);

interface IScreenReaderHelperProps {
   href: string;
   text: string;
}

export default ScreenReaderHelper;